import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import TargetExplorer from '../../components/organisms/targetExplorer/TargetExplorer';
import LoaderExplorer from '../../components/organisms/loaderExplorer/LoaderExplorer';
import { Button, Grid } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { ISpokeSearchParams } from "../../store/spokes/types";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSpokesListRequest} from '../../store/spokes/actions';
import OverRideExplorer from "../../components/organisms/overRideExplorer/OverRideExplorer";
import OverrideRequestExplorer from "../../components/organisms/overrideRequestsExplorer/OverrideRequestsExplorer";
import { getRoleClaimsSelector } from '../../store/auth/selectors';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    label?: String;
}

const tabs: TabPanelProps[] = [
    {
        index: 0,
        value: 0,
        label: "Data Loaders",
    },
    {
        index: 1,
        value: 1,
        label: "Data Targets",
    },
    {
        index: 2,
        value: 2,
        label: "Overrides",
    },
    {
        index: 3,
        value: 3,
        label: "Override Requests",
    },
];

const requestTargetEmail = () => {
    window.open("https://riotinto.service-now.com/esc?id=sc_cat_item&sys_id=36d0848487c4b1d0f38c64673cbb35fe", "_blank");
}

const requestTargetConnectionEmail = () => {
    window.open("https://riotinto.service-now.com/esc?id=sc_cat_item&sys_id=36d0848487c4b1d0f38c64673cbb35fe", "_blank");
}

const requestToLoadToTargetEmail = () => {
    window.open("https://riotinto.service-now.com/esc?id=sc_cat_item&sys_id=36d0848487c4b1d0f38c64673cbb35fe", "_blank");
}

const requestUserSchemaEmail = () => {
    window.open("https://riotinto.service-now.com/esc?id=sc_cat_item&sys_id=36d0848487c4b1d0f38c64673cbb35fe", "_blank");
}




const TabPanel = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}


const MyAssets = () => {
    const [value, setValue] = React.useState(0);
      const roles = useSelector(getRoleClaimsSelector); // roles  - IDP.Admin or IDP.User
    
      const [isAdmin, setIsAdmin] = React.useState(false);
    const navigate = useNavigate();

    const requestOverridesLink = (event: React.MouseEvent<HTMLButtonElement>) => {
        const url = `/NewOverrideRequest`;
        if (event.ctrlKey) {
            window.open(url, '_blank')
        } else {
            navigate('/NewOverrideRequest')
        }
    }

    const searchData = (event: React.MouseEvent<HTMLButtonElement>) => {
        const url = `/SearchData`;
        if (event.ctrlKey) {
            window.open(url, '_blank')
        } else {
            navigate(url);
        }

    }
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const dispatch = useDispatch();

    const spokeParams: ISpokeSearchParams = {
        count: true,
        top: 100,
        skip: 0,
        name: [],
        owner: [],
    };

    useEffect(() => {
        dispatch(fetchSpokesListRequest(spokeParams));
    });

    useEffect(() => {
    if (roles && roles.length > 0) {
        setIsAdmin(roles.includes("IDP.Admin") ? true : false);
    }
    }, [roles]);

    return (
        <>
            <Grid container direction="row" justifyContent="center" alignItems="center">
                <Grid item xs={6}>
                    <Box display="flex" justifyContent="flex-start">
                        <h1 style={{ textAlign: "left" }}>My Assets</h1>
                    </Box>
                </Grid>
                <Grid item xs={6}>
                    <Box display="flex" justifyContent="flex-end">
                        <Button id="d77a87a5-ad9f-472f-8801-0dfdfac6cc16" color="primary" variant="contained" onClick={searchData} >
                            Search Data
                        </Button>
                    </Box>
                </Grid>
            </Grid>
            <Box sx={{ width: '100%', background: "#fefefe", borderRadius: "10px" }}>

                <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: 1 }}>
                    <Tabs value={value} onChange={handleChange} aria-label="resource explorer">
                        {tabs.map((item) => (
                            <Tab key={item.index} label={item.label} style={{ fontWeight: "bold", padding: "20px 30px" }} />
                        ))}
                    </Tabs>
                </Box>

                <TabPanel value={value} index={0}>
                    <LoaderExplorer personal={true} selectable={"no"} isAdmin={true} displayActionButtons={true} />
                </TabPanel>

                <TabPanel value={value} index={1}>
                    <TargetExplorer personal={true} isAdmin={true} />
                </TabPanel>

                <TabPanel value={value} index={2}>
                    <OverRideExplorer myOverrides={true}/>
                </TabPanel>

                <TabPanel value={value} index={3}>
                    <OverrideRequestExplorer myOverrideRequests={true}/>
                </TabPanel>

            </Box>
            {isAdmin && (
                <Box display="flex" padding={2} justifyContent="flex-start" style={{ marginBottom: '1em' }}>
                    <Grid container direction="row" justifyContent="center" alignItems="center">
                        <Grid item xs={12} >
                            <Button id="115a43d5-7a9e-4e1c-baaa-3f571f35b524" color="primary" variant="contained" onClick={requestTargetEmail} style={{ marginRight: '1em', marginTop: '1em' }} >
                                Request New Target
                            </Button>
                            <Button id="4c03785c-6715-4ed9-95f3-a08d81263988" color="primary" variant="contained" onClick={requestTargetConnectionEmail} style={{ marginRight: '1em', marginTop: '1em' }} >
                                Request New Target Connection
                            </Button>
                            <Button id="3ff65724-dc65-4b31-9b2a-f82fb5aab2d0" color="primary" variant="contained" onClick={requestToLoadToTargetEmail} style={{ marginRight: '1em', marginTop: '1em' }} >
                                Request to Load Target
                            </Button>
                            <Button id="f2c91f33-e9b4-483d-9956-16e60ffd9d80" color="primary" variant="contained" onClick={requestUserSchemaEmail} style={{ marginRight: '1em', marginTop: '1em' }}>
                                Request User Schema
                            </Button>
                            <Button id="0b6dbb79-8154-4335-b604-4e8bc2cc3a04" color="primary" variant="contained" onClick={requestOverridesLink} style={{ marginRight: '1em', marginTop: '1em' }}>
                                Request New Override
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            )}
        </>
    );
};

export default MyAssets;